import { IconActivity, IconOutcome, IconParticipation } from 'src/icons';

type ActivityFieldProps = {
  type: 'activity' | 'participation' | 'outcome';
  value?: string | string[];
};

const iconMap = {
  activity: IconActivity,
  participation: IconParticipation,
  outcome: IconOutcome,
};

const labelMap = {
  activity: 'Activity',
  participation: 'Participation',
  outcome: 'Outcome',
};

export const BillingActivityField = ({ type, value }: ActivityFieldProps) => {
  const Icon = iconMap[type];

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-1">
        <div className="flex h-5 w-5 items-center justify-center rounded-full bg-secondary-900">
          <Icon className="text-secondary-300" />
        </div>
        <span className="text-neutral-300 typography-caption-md">{labelMap[type]}:</span>
      </div>
      {value && (
        <div className="flex flex-wrap gap-2">
          {Array.isArray(value) ? (
            value.map((v, index) => (
              <div key={index} className="flex h-8 items-center rounded bg-neutral-950 px-3">
                <span className="!leading-[125%] text-neutral-200 typography-loud-xs">{v}</span>
              </div>
            ))
          ) : (
            <div className="flex h-8 items-center rounded bg-neutral-950 px-3">
              <span className="text-neutral-200 typography-loud-xs">{value}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
